/**
 * Created by rhillion on 01/07/2017.
 */
import React, {Component} from 'react'
import {Container} from 'semantic-ui-react'
import 'react-datetime/css/react-datetime.css';
import {firebaseDB} from './helpers/fire'

export default class PlaceEdit extends Component {

    state = {
        place: {
            status: 'active'
        }
    }

    place = {};

    constructor(props) {
        super(props)

        this.save = this.save.bind(this)
        this.persist = this.persist.bind(this)
        this.updatePlace = this.updatePlace.bind(this)
        this.textChange = this.textChange.bind(this)
        this.radioChange = this.radioChange.bind(this)
    }

    componentWillMount() {
        this.new = true;
        if (this.props.match.params.id) {
            this.new = false;
            this.place = firebaseDB.ref('places').child(this.props.match.params.id);
            this.place.once('value', snapshot => {
                this.setState({place: snapshot.val()});
            });
        }
        else
            this.place = firebaseDB.ref('places').push();
    }

    load(entity) {
        firebaseDB.ref(entity).on('value', snapshot => {
            var data = snapshot.val();
            if (data) {
                var records = Object.keys(data).map(key => data[key]), stateObj = {};
                stateObj[entity] = records;
                this.setState(stateObj);
            }
        });
    }

    save() {
        if (!this.formIsValid()) {
            alert(`Please correct ${this.invalid.toString()}`)
            return;
        }
        this.persist();
    }


    persist(){
        this.state.place.key = this.state.place.value = this.place.key;
        this.place.set(this.state.place).then(record => {
                console.log('record updated')
        });
    }

    formIsValid(){
        this.invalid = [];
        for(var i in this.invalidFields){
            if(this.invalidFields[i]) this.invalid.push(i)
        }
        return this.invalid.length < 1;
    }

    textChange(event) {
        this.updatePlace(event.target.name, event.target.value);
    }

    radioChange(event) {
        this.updatePlace(event.target.name, event.target.value);
    }

    updatePlace(key, val) {
        this.state.place[key] = val;
        this.setState({place: this.state.place});
    }

    render() {
        if (this.state.place.key  || this.new)
            return (
                    <form className="ui form">

                        <div className="ui form">
                            <div className="grouped fields">
                                <label>Status</label>
                                <div className="field">
                                    <div className="ui radio checkbox">
                                        <input id="active" onClick={this.radioChange} type="radio" name="status"
                                               defaultValue="active"
                                               defaultChecked={this.state.place.status === 'active'}/>
                                        <label htmlFor="active">Active</label>
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="ui radio checkbox">
                                        <input id="inactive" onClick={this.radioChange} type="radio" name="status"
                                               defaultValue="inactive"
                                               defaultChecked={this.state.place.status === 'inactive'}/>
                                        <label htmlFor="inactive">Inactive</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="field">
                            <label>Title</label>
                            <input type="text" name="text" placeholder="Title" onChange={this.textChange}
                                   defaultValue={this.state.place.text}/>
                        </div>

                        <div className="ui form">
                            <div className="grouped fields">
                                <label>Coordinates</label>
                                <div className="field">
                                    <input type="text" name="lat" placeholder="Lat" onChange={this.textChange}
                                           defaultValue={this.state.place.lat}/>
                                </div>

                                <div className="field">
                                    <input type="text" name="lng" placeholder="Lng" onChange={this.textChange}
                                           defaultValue={this.state.place.lng}/>
                                </div>
                            </div>
                        </div>

                        <button className="ui button" type="button" onClick={this.save}>Submit</button>
                    </form>
            )
        else
            return (
                <Container>
                    Loading...
                </Container>
            )
    }
}


// WEBPACK FOOTER //
// ./src/PlaceEdit.js